module.exports = __webpack_public_path__ + "static/media/allie18.44650573.jpg";